import {
  type IEvent,
  PlayerEvents,
  type IEventDispatcher,
  StreamType,
  playerStateManager,
} from '@4tn/core-audio-player-shared';
import { configureUTag } from '@4tn/core-audio-player-analytics';
import packageJson from '../../package.json';

/**
 * Function is used as middleware between the player and Tealium analytics. We are relaying on a simple
 * player state management to limit dispatching of certain events.
 * Note: Cleanup of the events is done within the configureUTag function
 */
export const analyticsMiddleware = (eventDispatcher: IEventDispatcher): (() => void) => {
  // init the player state with the default values
  playerStateManager.setState({
    trackStreamStart: true,
    playerVersion: packageJson?.version,
  });

  // Local state variables
  let contentId: string | undefined;

  // Limit dispatching of the steam start once per stream
  eventDispatcher.on(PlayerEvents.STREAM_START, (event: IEvent) => {
    const { trackStreamStart } = playerStateManager.getState();
    // TODO - Check condition when changed to trackStreamStart ? true : contentId !== event.media.contentId
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    playerStateManager.setState({ trackStreamStart: trackStreamStart || contentId !== event.media.contentId });
    contentId = event.media.contentId;
  });

  // Dispatch the stream start event after the stream end
  eventDispatcher.on(PlayerEvents.STREAM_ENDED, () => {
    playerStateManager.setState({ trackStreamStart: true });
  });

  // Stop dispatching stream start after user clicks on stop for radio stations
  eventDispatcher.on(PlayerEvents.STREAM_STOP, (event: IEvent) => {
    const isStation = event?.media?.contentType === StreamType.STATION;
    playerStateManager.setState({ trackStreamStart: !isStation });
  });

  // Stop dispatching stream start after stream is disconnected
  eventDispatcher.on(PlayerEvents.PLAYER_DISCONNECTED, () => {
    playerStateManager.setState({ trackStreamStart: false });
  });

  // Dispatch the stream start after the stream error on the same stream
  eventDispatcher.on(PlayerEvents.STREAM_ERROR, () => {
    playerStateManager.setState({ trackStreamStart: true });
  });

  return configureUTag(eventDispatcher);
};
